import { getOpenWidgetButton, getTalkativeEngageElement } from "./helpers/get-talkative-elements.js";

//#region src/talkative-config.ts
const hideButton = () => {
	setTimeout(() => {
		const button = getOpenWidgetButton();
		if (button) button.style.display = "none";
		const app = getTalkativeEngageElement();
		if (app) app.style.zIndex = "auto";
	}, 0);
};
const talkativeConfig = { events: {
	ready() {
		hideButton();
		window.talkativeApi.ui.hide();
	},
	visibilityChange() {
		hideButton();
	},
	completeInteraction() {
		window.talkativeApi.ui.hide();
	}
} };

//#endregion
export { talkativeConfig };